import { render, staticRenderFns } from "./InformacaoModal.vue?vue&type=template&id=b46c6126&scoped=true"
import script from "./InformacaoModal.vue?vue&type=script&lang=js"
export * from "./InformacaoModal.vue?vue&type=script&lang=js"
import style0 from "./InformacaoModal.vue?vue&type=style&index=0&id=b46c6126&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b46c6126",
  null
  
)

export default component.exports